module.exports = __webpack_public_path__ + "static/img/success.e4581c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success.png
// module id = 4AGf
// module chunks = 4